import { forwardRef, ImgHTMLAttributes } from 'react';

type Props = Omit<ImgHTMLAttributes<HTMLImageElement>, 'onClick'> & {
  onClick?: (event: any) => void;
  aid?: string;
  variant?: string;
  disabled?: boolean;
  // Some call sites pass the attribute all-lowercase; forwarded as `aria-describedby`.
  ariadescribedby?: string;
  [key: string]: any;
};

const ClickableImage = forwardRef<HTMLImageElement, Props>((props, ref) => {
  const { ariadescribedby, ...rest } = props;

  return (
    <img
      role="presentation"
      alt=""
      ref={ref}
      aria-describedby={rest['aria-describedby'] ?? ariadescribedby}
      {...rest}
    />
  );
});

ClickableImage.displayName = 'ClickableImage';

export default ClickableImage;
